{
  "CustomNameLabel": "Nome:",
  "CustomWidthLabel": "Larghezza (0 - 100):",
  "CustomSettings_SectionHeader": "Impostazioni personalizzate",
  "NAME": "CustomSettings"
}